import { useEffect } from 'react';

const SeoSchema = () => {
  useEffect(() => {
    const siteUrl = import.meta.env.VITE_SITE_URL || 'https://worldcuproadtrip.readdy.ai';
    
    // Travel Agency Schema
    const travelAgencySchema = {
      "@context": "https://schema.org",
      "@type": "TravelAgency",
      "name": "WorldCup Roadtrip",
      "description": "Chuyên tổ chức tour World Cup 2026 kết hợp roadtrip khám phá nước Mỹ dành riêng cho người Việt Nam",
      "url": siteUrl,
      "telephone": "+84901234567",
      "email": "info@worldcuproadtrip.vn",
      "address": {
        "@type": "PostalAddress",
        "addressCountry": "VN",
        "addressLocality": "TP.HCM"
      },
      "serviceType": ["World Cup Tours", "USA Roadtrip", "Sports Tourism"],
      "areaServed": "Vietnam"
    };

    // Product/Service Schema
    const productSchema = {
      "@context": "https://schema.org",
      "@type": "Product",
      "name": "World Cup 2026 & USA Roadtrip Tour Package",
      "description": "Tour combo World Cup 2026 và USA Roadtrip độc quyền cho người Việt. Xem World Cup trực tiếp tại Mỹ, kết hợp roadtrip khám phá công viên quốc gia.",
      "brand": {
        "@type": "Brand",
        "name": "WorldCup Roadtrip"
      },
      "offers": {
        "@type": "AggregateOffer",
        "priceCurrency": "USD",
        "lowPrice": "2500",
        "highPrice": "8500",
        "offerCount": "3"
      },
      "aggregateRating": {
        "@type": "AggregateRating",
        "ratingValue": "5",
        "reviewCount": "3"
      }
    };

    // FAQ Schema
    const faqSchema = {
      "@context": "https://schema.org",
      "@type": "FAQPage",
      "mainEntity": [
        {
          "@type": "Question",
          "name": "Có cần visa Mỹ? Làm sao để xin?",
          "acceptedAnswer": {
            "@type": "Answer",
            "text": "Có, bạn cần visa du lịch Mỹ (B1/B2). Chúng tôi sẽ hỗ trợ hồ sơ và hướng dẫn chi tiết quy trình xin visa."
          }
        },
        {
          "@type": "Question",
          "name": "Đảm bảo vé trận đấu như thế nào?",
          "acceptedAnswer": {
            "@type": "Answer",
            "text": "Chúng tôi có đối tác chính thức với FIFA và các nhà cung cấp vé ủy quyền. Vé được đảm bảo 100% hoặc hoàn tiền."
          }
        },
        {
          "@type": "Question",
          "name": "Không biết lái xe có tham gia được không?",
          "acceptedAnswer": {
            "@type": "Answer",
            "text": "Hoàn toàn được! Chúng tôi có tùy chọn xe bus luxury hoặc ghép nhóm với tài xế chuyên nghiệp."
          }
        },
        {
          "@type": "Question",
          "name": "Đi một mình có ghép đoàn không?",
          "acceptedAnswer": {
            "@type": "Answer",
            "text": "Có, chúng tôi có dịch vụ ghép đoàn cho khách lẻ với những người Việt Nam cùng sở thích."
          }
        },
        {
          "@type": "Question",
          "name": "Tour có phù hợp với trẻ em không?",
          "acceptedAnswer": {
            "@type": "Answer",
            "text": "Có, chúng tôi có gói gia đình với hoạt động phù hợp mọi lứa tuổi và chăm sóc đặc biệt cho trẻ em."
          }
        }
      ]
    };

    // Event Schema for World Cup 2026
    const eventSchema = {
      "@context": "https://schema.org",
      "@type": "SportsEvent",
      "name": "FIFA World Cup 2026",
      "description": "Tour xem World Cup 2026 trực tiếp tại Mỹ kết hợp roadtrip khám phá",
      "startDate": "2026-06-11",
      "endDate": "2026-07-19",
      "location": {
        "@type": "Place",
        "name": "United States",
        "address": {
          "@type": "PostalAddress",
          "addressCountry": "US"
        }
      },
      "organizer": {
        "@type": "Organization",
        "name": "WorldCup Roadtrip",
        "url": siteUrl
      }
    };

    // WebPage Schema
    const webPageSchema = {
      "@context": "https://schema.org",
      "@type": "WebPage",
      "name": "World Cup 2026 USA Roadtrip - Tour Combo Xem Bóng Đá & Phượt Mỹ",
      "description": "Tour combo World Cup 2026 & USA Roadtrip độc quyền cho người Việt. Xem World Cup trực tiếp tại Mỹ, kết hợp roadtrip khám phá công viên quốc gia.",
      "url": siteUrl,
      "inLanguage": "vi",
      "isPartOf": {
        "@type": "WebSite",
        "name": "WorldCup Roadtrip",
        "url": siteUrl
      }
    };

    // Insert schemas into head
    const schemas = [
      travelAgencySchema,
      productSchema,
      faqSchema,
      eventSchema,
      webPageSchema
    ];

    schemas.forEach((schema, index) => {
      const script = document.createElement('script');
      script.type = 'application/ld+json';
      script.id = `schema-${index}`;
      script.text = JSON.stringify(schema);
      document.head.appendChild(script);
    });

    // Cleanup
    return () => {
      schemas.forEach((_, index) => {
        const script = document.getElementById(`schema-${index}`);
        if (script) {
          document.head.removeChild(script);
        }
      });
    };
  }, []);

  return null;
};

export default SeoSchema;
